import ListingDetailV1 from './ListingDetailV1'

export default ListingDetailV1
